import type { ReactNode } from "react";
import "./ScheduleCancellationDialog.scss";
import { useTranslation } from "react-i18next";
import CustomDialog from "@/shared/components/generic/custom-dialog/CustomDialog.tsx";
import IconArrowLeftUturnSquare from "@/shared/components/generic/icons/IconArrowLeftUturnSquare.tsx";
import DialogActionsButtons from "@/shared/components/generic/dialog-actions-buttons/DialogActionsButtons.tsx";
import Button from "@/shared/components/generic/button/Button.tsx";
import { Level, Size } from "@/shared/components/generic/UiEnums.ts";
import useCancelDraftSchedules from "@/pages/human-resources/time-management/services/hooks/useCancelDraftSchedules.ts";
import useVisibleDraftSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleDraftSchedules.ts";

interface Properties {
  onClose: () => void;
}

export default function ScheduleCancellationDialog(
  props: Properties,
): ReactNode {
  const { t } = useTranslation(["common", "humanResources"]);
  const cancelDraftSchedules = useCancelDraftSchedules();
  const visibleDrafts = useVisibleDraftSchedules();

  return (
    <CustomDialog
      open={true}
      onClose={props.onClose}
      icon={IconArrowLeftUturnSquare}
      title={t(
        "humanResources:timeManagement.scheduleCancellation.goToPreviousVersion",
      )}
    >
      <div className="schedule-cancellation-dialog">
        <div className="content">
          <div className="warning">
            {t(
              "humanResources:timeManagement.scheduleCancellation.aboutToCancel",
            )}
          </div>
          <div className="continue">{t("common:callToContinue")}</div>
          <DialogActionsButtons>
            <Button
              onClick={props.onClose}
              label={t("common:actions.cancel")}
              size={Size.SMALL}
              level={Level.SECONDARY}
            />
            <Button
              onClick={() => {
                cancelDraftSchedules.mutate(visibleDrafts);
                props.onClose();
              }}
              label={t("common:choice.yes")}
              size={Size.SMALL}
              level={Level.PRIMARY}
            />
          </DialogActionsButtons>
        </div>
      </div>
    </CustomDialog>
  );
}
